/* eslint-disable */
/* ***********************************************************
* A short word on how to use this automagically generated file.
* We're often asked in the ignite gitter channel how to connect
* to a to a third party api, so we thought we'd demonstrate - but
* you should know you can use sagas for other flow control too.
*
* Other points:
*  - You'll need to add this saga to sagas/index.js
*  - This template uses the api declared in sagas/index.js, so
*    you'll need to define a constant in that file.
*************************************************************/

import { call, put } from 'redux-saga/effects'
import MessagesActions from '../Redux/MessagesRedux'
import PostsActions from '../Redux/PostsRedux'
//import RNFetchBlob from "react-native-fetch-blob"

// see:  https://jaketrent.com/post/pause-in-redux-saga/
export default function pause(delay) {
  return new Promise(resolve => {
    setTimeout(_ => {
      resolve()
    }, delay.millis)
  })
}

const s3Upload = (details) => {
  console.tron.display({
    name: 's3Upload',
    preview: 'details',
    value: {
      presignedUrl: details.presignedUrl,
      // details: details
    }
  })
  const headers = {
    'Content-Type': 'application/octet-stream',
  }
  // https://github.com/joltup/react-native-fetch-blob
  if (details.base64 && details.base64.length > 10) {
    console.tron.log("trying to upload from base64")
    if (false)
    return RNFetchBlob.fetch('PUT', details.presignedUrl, headers, details.base64)
      .uploadProgress({ interval: details.interval }, (written, total) => {
      })
  }
  else {
    console.log("trying to upload from blob uri = " + details.uri)
    var path = details.uri.replace(/^file:../, '')
    console.log("trying to upload from " + path)
    if (false)
    return RNFetchBlob.fetch('PUT', details.presignedUrl, headers, RNFetchBlob.wrap(path/*details.uri*/))
      .uploadProgress({ interval: details.interval }, (written, total) => {
        console.log("upload progress " + written + " " + total)
      })
      .catch((errorMessage, statusCode) => {
        console.log("upload error " + errorMessage + " " + statusCode)
      })
  }

}
export function* updateChatState(api, action) {

}
export function* chatStopTyping(api, action) {
  
}
export function* getUnreadMessages(api, action) {

  try {
    const response = yield call(api.getUnreadMessages)

    // success?
    if (response.ok) {
      yield put(MessagesActions.getUnreadMessagesSuccess(response))
    } else {
      yield put(MessagesActions.getUnreadMessagesFailure(response))
    }
  } catch (e) {
    yield put(MessagesActions.getUnreadMessagesFailure())
  }

}

export function* markChatRead(api, action) {
  console.tron.display({name: 'markChatRead', preview: `action`, value: {action: action}})
  try {
    const response = yield call(api.markChatRead, action.chatId)
  } catch (e) {
  }
}

export function* deleteChat(api, action) {
  const { data } = action
  try {
    const response = yield call(api.deleteChat, data)
    if (response.ok) yield put(MessagesActions.deleteChatSuccess(data))
    else yield put(MessagesActions.deleteChatFailure(response))
  } catch (e) {
    yield put(MessagesActions.deleteChatFailure())
  }
}
export function* getMessages(api, action) {

  if (typeof action.clearChatId != 'undefined' && action.clearChatId) {
    try {
      const clearResponse = yield call(api.markChatRead, action.clearChatId)
    } catch (e) {
    }
  }

  // get current data from Store
  // const currentData = yield select(MessagesSelectors.getData)
  // make the call to the api
  const response = yield call(api.getmessages)

  // success?
  if (response.ok) {
    console.tron.display({
      name: `Message chat`,
      preview: ``,
      value: {
        response: response
      }
    })

    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(MessagesActions.messagesSuccess(response))
  } else {
    yield put(MessagesActions.messagesFailure())
  }
}

export function* getChat(api, action = { UserId: { UserId: '' } }) {
  const response = yield call(api.getChat, action.UserId.UserId)
  response.ok
    ? yield put(MessagesActions.chatSuccess(response))
    : yield put(MessagesActions.chatFailure(response))
}
export function* chatSend(api, action) {

  let response;
  if (action.data.PlainText == "[Image]") {

    const responsImageUrl = yield call(api.getChatImageUrl, action.data.ChatId)

    console.tron.display({
      name: `chatSend`,
      preview: ``,
      value: {
        state: action.data
      }
    })


    if (responsImageUrl.ok) {
      const { data: { data } } = responsImageUrl



      var presignedUrl = action.data.Image.base64 ? data[0].thumbImage._url : data[0].video._url

      var preRenderedMovie = action.data.Image.movieUrlAsNSString



      var b64 = null
      if (action && action.data && action.data.Image && action.data.Image.stillImageAsBase64)
        b64 = action.data.Image.stillImageAsBase64

      // if uri is set to a file url and base64 is null, upload will be movie
      // if base64 is set to a string, upload will be a still image
      let detailedFiles = {
        presignedUrl: action.data.Image.base64 ? data[0].thumbImage._url : data[0].video._url,
        interval: 500,
        base64: preRenderedMovie ? null : b64,
        uri: preRenderedMovie || null // a file url of the movie pre rendered for trials, could be large
      }

      if (preRenderedMovie) { // wait for rendered vid

        var result = { "test": "abc" }

        while (!result.finalRenderedVideo) {
          yield put(PostsActions.checkVideoRenderResults(result))

          console.log("checkVideoRenderResults result = " + JSON.stringify(result))

          yield call(pause, { millis: 500 })
        }

        detailedFiles.uri = result.finalRenderedVideo // upload the final rendered video, not prerendred
      }

      yield put(PostsActions.createStandardPostProgress(0.0)) // get rid of video render blue bar

      if (preRenderedMovie) {
        console.tron.display({
          name: `upload thumb`,
          preview: ``,
          value: {
            state: data[0]
          }
        })

        // upload thumb
        let thumbVideo = {
          presignedUrl: data[0].thumb._url + "-thumb", // to do, this name is incorrect should not have -thumb but seems to work
          interval: 500,
          base64: b64,

        }
        yield call(s3Upload, thumbVideo)
      }

      const responseUpload = yield call(s3Upload, detailedFiles)

      // if we have a movie we also want to upload the poster frame still iamge
      if (preRenderedMovie) {

        // if uri is set to a file url and base64 is null, upload will be movie
        // if base64 is set to a string, upload will be a still image
        let detailedFilesPoster = {
          presignedUrl: data[0].thumbImage._url,
          interval: 500,
          base64: b64,
          uri: null // a file url of the movie pre rendered for trials, could be large
        }

        yield call(s3Upload, detailedFilesPoster)

      }

      if (responseUpload.respInfo.status == 200) {
        const isSendVideoData = action.data.Image.base64 ? `[${data[0].id} JPEG ${action.data.aspectRatio}]` : `[${data[0].id} MP4 ${action.data.aspectRatio}]`
        const dataMessage =
        {
          Message: isSendVideoData,

          ToId: action.data.ToId,

          PlainText: `[Image]`,

          ChatId: action.data.ChatId
        }
        console.tron.display({
          name: `response saga dataMessage`,
          preview: ``,
          value: {
            state: dataMessage
          }
        })
        response = yield call(api.sendChat, dataMessage)
        console.tron.display({
          name: `response saga send image`,
          preview: ``,
          value: {
            state: response
          }
        })

        response.ok
          ? yield put(MessagesActions.chatSendSuccess(response))
          : yield put(MessagesActions.chatSendFailure(response))
      } else {
        yield put(MessagesActions.chatSendFailure(response))
      }
      console.tron.display({
        name: `responseUpload`,
        preview: ``,
        value: {
          state: responseUpload
        }
      })

    } else {
      yield put(MessagesActions.chatSendFailure(response))
    }


  } else {
    response = yield call(api.sendChat, action.data)
    response.ok
      ? yield put(MessagesActions.chatSendSuccess(response))
      : yield put(MessagesActions.chatSendFailure(response))
  }


}
